<template>
  <div class="flex-1">
    <slot></slot>
  </div>
</template>
